module.exports = __webpack_public_path__ + "img/onsite_customer.88d8e778.png";